export default [
  {
    key: 'employeeId',
    label: 'breadcrumb.employee',
    type: 'async-single-selection',
    repository: 'allOperator',
    isCustomParams: true,
    clearable: true,
    mustExcludedIds: [],
    alwaysFresh: true,
    selectionKey: 'id',
    selectionLabel: 'name',
    placeholder: 'placeholder.selectEmployee',
  },
  {
    key: 'date',
    label: 'field.date',
    type: 'date',
    md: 4,
    lg: 4,
  },
];